module.exports = __webpack_public_path__ + "img/home_3.73def082.jpg";